export default "__VITE_ASSET__DUXK07p0__"